import { render } from "./NotesPopup.vue?vue&type=template&id=c1ec31a0&scoped=true"
import script from "./NotesPopup.vue?vue&type=script&lang=js"
export * from "./NotesPopup.vue?vue&type=script&lang=js"

import "./NotesPopup.vue?vue&type=style&index=0&id=c1ec31a0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1ec31a0"]])

export default __exports__